import { encryptData, decryptData } from "../../configs/encryption";
import { userInstance as axios } from "../../configs/axiosInstance";
import Cookies from "js-cookie";
const isEncryptionEnabled = import.meta.env.VITE_ENCRYPTION === "true";


//  Know Your Constitution  apis -+------------------------+-


// list-constitution-parts
export const getConstitutionParts = async (data) => {
  const payload = isEncryptionEnabled
    ? encryptData({ ...data })
    : { ...data };

  try {
    const response = await axios.get("/list-constitution-parts", {
      params: isEncryptionEnabled ? { reqData: payload } : payload,
    });

    const decrypted = isEncryptionEnabled
      ? decryptData(response)
      : response.data;

    return decrypted;
  } catch (error) {
    console.error("Error inside getConstitutionParts:", error);
    throw error;
  }
};

// list-constitution-articles

export const getConstitutionArticles = async (data) => {
  const payload = isEncryptionEnabled
    ? encryptData({ ...data })
    : { ...data };

  try {
    const response = await axios.get("/list-constitution-articles", {
      params: isEncryptionEnabled ? { reqData: payload } : payload,
    });

    const decrypted = isEncryptionEnabled
      ? decryptData(response)
      : response.data;

    return decrypted;
  } catch (error) {
    console.error("Error inside getConstitutionArticles:", error);
    throw error;
  }
};


// Election Campinion Apis 

// list-election-companion

export const getElectionCampanion = async (data) => {
  const payload = isEncryptionEnabled
    ? encryptData({ ...data })
    : { ...data };

  try {
    const response = await axios.get("/list-election-companion", {
      params: isEncryptionEnabled ? { reqData: payload } : payload,
    });

    const decrypted = isEncryptionEnabled
      ? decryptData(response)
      : response.data;

    return decrypted;
  } catch (error) {
    console.error("Error inside getElectionCampanion:", error);
    throw error;
  }
};

// list-government-updates
export const getGovernmentUpdates = async (data) => {
  const payload = isEncryptionEnabled
    ? encryptData({ ...data })
    : { ...data };

  try {
    const response = await axios.get("/list-government-updates", {
      params: isEncryptionEnabled ? { reqData: payload } : payload,
    });

    const decrypted = isEncryptionEnabled
      ? decryptData(response)
      : response.data;

    return decrypted;
  } catch (error) {
    console.error("Error inside getElectionCampanion:", error);
    throw error;
  }
};

//list-ministers
export const getGovernmentMinisters = async (data) => {
  const payload = isEncryptionEnabled
    ? encryptData({ ...data })
    : { ...data };

  try {
    const response = await axios.get("/list-ministers", {
      params: isEncryptionEnabled ? { reqData: payload } : payload,
    });

    const decrypted = isEncryptionEnabled
      ? decryptData(response)
      : response.data;

    return decrypted;
  } catch (error) {
    console.error("Error inside getGovernmentMinisters:", error);
    throw error;
  }
};

//list-argument-dna

export const getArgumentDNA = async (data) => {
  const payload = isEncryptionEnabled
    ? encryptData({ ...data })
    : { ...data };

  try {
    const response = await axios.get("/list-argument-dna", {
      params: isEncryptionEnabled ? { reqData: payload } : payload,
    });

    const decrypted = isEncryptionEnabled
      ? decryptData(response)
      : response.data;

    return decrypted;
  } catch (error) {
    console.error("Error inside getArgumentDNA:", error);
    throw error;
  }
};




//add Customer
export const argueDNAResult = async (data) => {

  const payload = isEncryptionEnabled
    ? { reqData: encryptData({ ...data  }) }
    : { ...data };

  try {
    const response = await axios.post(`/argue-dna-result`, payload);
    const decrypted = isEncryptionEnabled ? decryptData(response) : response.data;
    return decrypted;
  } catch (error) {
    console.error("Error inside addCustomer:", error);
    throw error;
  }
};


// get-website-latest-news

export const getWebLatestNews = async (data) => {
  const payload = isEncryptionEnabled
    ? encryptData({ ...data })
    : { ...data };

  try {
    const response = await axios.get("/get-website-latest-news", {
      params: isEncryptionEnabled ? { reqData: payload } : payload,
    });

    const decrypted = isEncryptionEnabled
      ? decryptData(response)
      : response.data;

    return decrypted;
  } catch (error) {
    console.error("Error inside getWebLatestNews:", error);
    throw error;
  }
};

// add-site-visitor

const SITE_SESSION_KEY = "site_session_id";
let memorySessionId = null;

const makeSessionId = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

// created once, then the saved one is reused (shared by all tabs, gone when site data is cleared)
export const getSiteSessionId = () => {
  try {
    let id = localStorage.getItem(SITE_SESSION_KEY);
    if (!id) {
      id = makeSessionId();
      localStorage.setItem(SITE_SESSION_KEY, id);
    }
    return id;
  } catch {
    if (!memorySessionId) memorySessionId = makeSessionId();
    return memorySessionId;
  }
};

export const hasSiteSessionId = () => {
  try {
    return Boolean(localStorage.getItem(SITE_SESSION_KEY));
  } catch {
    return true;
  }
};




// get-site-visitor-count

export const getSiteVisitorCount = async (data = {}) => {
  const payload = isEncryptionEnabled
    ? encryptData({ ...data })
    : { ...data };

  try {
    const response = await axios.get("/get-site-visitor-count", {
      params: isEncryptionEnabled ? { reqData: payload } : payload,
    });

    const decrypted = isEncryptionEnabled
      ? decryptData(response)
      : response.data;

    return decrypted;
  } catch (error) {
    console.error("Error inside getSiteVisitorCount:", error);
    throw error;
  }
};
 
 



//////////////////////////============/////////////////

// PATH: src/api/WebsiteApis/apis.js
// Is file mein purana `addSiteVisitor` hata ke ye dono paste karo
// (getClientIp + addSiteVisitor). Baaki imports / getSiteSessionId /
// isEncryptionEnabled / encryptData / decryptData jaise pehle the waise hi rahenge.

// ---- public IP lookup (cached for the page session) ----
let cachedIp = null;
let ipPromise = null;

const IP_ENDPOINTS = [
  "https://api.ipify.org?format=json",
  "https://api64.ipify.org?format=json",
];

const fetchIpFrom = async (url, timeoutMs = 3000) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(url, { signal: controller.signal });
    if (!res.ok) throw new Error(`IP lookup failed: ${res.status}`);
    const json = await res.json();
    return typeof json?.ip === "string" ? json.ip : "";
  } finally {
    clearTimeout(timer);
  }
};

// never throws; returns "" when the IP can't be fetched (adblock, offline, etc.)
export const getClientIp = async () => {
  if (cachedIp) return cachedIp;
  if (ipPromise) return ipPromise;

  ipPromise = (async () => {
    for (const url of IP_ENDPOINTS) {
      try {
        const ip = await fetchIpFrom(url);
        if (ip) {
          cachedIp = ip;
          return ip;
        }
      } catch {
        // try next endpoint
      }
    }
    return "";
  })();

  const ip = await ipPromise;
  ipPromise = null; // allow a retry later if it failed
  return ip;
};

export const addSiteVisitor = async () => {
  const ipaddress = await getClientIp();

  const data = {
    sessionid: getSiteSessionId(),
    ipaddress, // "" if lookup failed, visitor is still recorded
  };

  const payload = isEncryptionEnabled
    ? { reqData: encryptData({ ...data }) }
    : { ...data };

  try {
    const response = await axios.post("/add-site-visitor", payload);
    const decrypted = isEncryptionEnabled ? decryptData(response) : response.data;
    return decrypted;
  } catch (error) {
    console.error("Error inside addSiteVisitor:", error);
    throw error;
  }
};